(function () {
  'use strict';
  if (window.__dtCartDrawer) return;
  window.__dtCartDrawer = true;

  /* Presentation only: no add/change/checkout logic is touched here. */
  var CFG = {
    mainHandle: 'shower-head', // main product rows always first (matches the cart-item--product-<handle> class)
    checkoutLabel: 'Secure Checkout - ',
    trustedText: 'Trusted by 10,000+ customers',
    badges: ['100-DAY RETURNS', 'FREE SHIPPING']
  };
  var script = document.currentScript;
  var MONEY_FORMAT = (script && script.getAttribute('data-money-format')) || '${{amount}}';

  function num(cents, dec, th, dp) {
    var s = (cents / 100).toFixed(dec).split('.');
    s[0] = s[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + th);
    return s.length > 1 ? s[0] + dp + s[1] : s[0];
  }
  function money(cents) {
    return String(MONEY_FORMAT).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="8" r="7"/><path d="M4.8 8.2l2.2 2.2 4.2-4.5"/></svg>';

  var totalCents = null, lastSig = '', fetching = false;

  function loadTotal() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { totalCents = c.total_price; applyDrawer(); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  function applyDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // title without the item count
    var h = drawer.querySelector('.drawer__heading');
    if (h) {
      var t = h.textContent.split('•')[0].trim();
      if (t && h.textContent.trim() !== t) h.textContent = t;
    }

    // hide the placeholder "Default Title" variant label
    [].forEach.call(drawer.querySelectorAll('.cart-drawer-item .product-option'), function (el) {
      if (/default title/i.test(el.textContent)) el.style.display = 'none';
    });

    // re-read the total whenever the rendered rows change
    var rows = drawer.querySelectorAll('.cart-drawer-item');
    var sig = [].map.call(rows, function (r) {
      var q = r.querySelector('.quantity__input');
      return r.id + ':' + (q ? q.value : '');
    }).join('|');
    if (sig !== lastSig) { lastSig = sig; loadTotal(); }

    // checkout button label: lock + "Secure Checkout - $total"
    var label = drawer.querySelector('#CartDrawer-Checkout .button__label');
    if (label && totalCents !== null) {
      var want = CFG.checkoutLabel + money(totalCents);
      if (label.getAttribute('data-dt-label') !== want) {
        label.innerHTML = LOCK + '<span>' + want + '</span>';
        label.setAttribute('data-dt-label', want);
      }
    }

    // trust block under the button
    var ctas = drawer.querySelector('.cart__ctas');
    if (ctas && !ctas.querySelector('.dt-cd-trust')) {
      var box = document.createElement('div');
      box.className = 'dt-cd-trust';
      var p = document.createElement('div');
      p.className = 'dt-cd-trust__text';
      p.textContent = CFG.trustedText;
      box.appendChild(p);
      ctas.appendChild(box);
    }
  }

  // /cart page: main product rows first (the drawer is ordered with CSS)
  function orderCartPage() {
    var main = document.querySelectorAll('tr.cart-item--product-' + CFG.mainHandle + ', .cart-items > .cart-item--product-' + CFG.mainHandle);
    [].forEach.call(main, function (row) {
      var parent = row.parentElement;
      if (parent && parent.firstElementChild !== row && !row.closest('cart-drawer')) parent.insertBefore(row, parent.firstElementChild);
    });
  }

  /* ---------- upsell carousel: arrows, variant price, Add ---------- */
  function updateArrows() {
    [].forEach.call(document.querySelectorAll('[data-dt-upsell]'), function (box) {
      var track = box.querySelector('[data-dt-track]');
      var prev = box.querySelector('[data-dt-arrow="-1"]'), next = box.querySelector('[data-dt-arrow="1"]');
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    });
  }
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-dt-arrow]');
    if (arrow) {
      var track = arrow.closest('[data-dt-upsell]').querySelector('[data-dt-track]');
      track.scrollBy({ left: parseInt(arrow.getAttribute('data-dt-arrow'), 10) * track.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest && e.target.closest('[data-dt-add]');
    if (!add || add.getAttribute('aria-busy') === 'true') return;
    var card = add.closest('[data-dt-card]');
    var sel = card && card.querySelector('[data-dt-variant]');
    var id = parseInt(sel ? sel.value : add.getAttribute('data-variant'), 10);
    if (!id) return;
    add.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        if (window.dtRenderCartDrawer) return window.dtRenderCartDrawer(res.json.items || [], res.json.sections, { open: true });
        window.location.href = '/cart';
      })
      .catch(function () {})
      .then(function () { add.removeAttribute('aria-busy'); });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-dt-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var price = sel.closest('[data-dt-card]').querySelector('[data-dt-price]');
    if (opt && price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-dt-track]')) updateArrows();
  }, true);

  /* upsell drag-to-scroll (mouse only; touch keeps the native swipe) */
  var drag = null, suppressClick = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('[data-dt-track]');
    if (!track || e.target.closest('button, select, option, input')) return; // Add / select never start a drag
    drag = { track: track, startX: e.clientX, startLeft: track.scrollLeft, moved: false, id: e.pointerId };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.startX;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.track.classList.add('is-grabbing');
      drag.track.style.scrollSnapType = 'none';
      try { drag.track.setPointerCapture(drag.id); } catch (err) {}
    }
    if (drag.moved) { drag.track.scrollLeft = drag.startLeft - dx; e.preventDefault(); }
  });
  function endDrag() {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    d.track.classList.remove('is-grabbing');
    var tl = d.track.getBoundingClientRect().left, best = null, bd = Infinity;
    [].forEach.call(d.track.querySelectorAll('[data-dt-card]'), function (c) {
      var off = c.getBoundingClientRect().left - tl;
      if (Math.abs(off) < bd) { bd = Math.abs(off); best = off; }
    });
    d.track.style.scrollSnapType = '';
    if (best !== null) d.track.scrollTo({ left: d.track.scrollLeft + best, behavior: 'smooth' });
    suppressClick = true; // a drag longer than 5px is not a click
    setTimeout(function () { suppressClick = false; }, 0);
    updateArrows();
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', function (e) {
    if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-dt-track]')) e.preventDefault();
  });

  /* ---------- header cart icon: keep the original SVG when the cart bubble section is re-rendered ----------
     The cart-icon-bubble section renders a different (default) icon than the customised header one;
     Shrine's renderContents and the gift sync both swap #cart-icon-bubble's markup. We keep the
     original <svg> and let only the count bubble update. */
  var iconSvg = null, iconObs = null;
  function bubbleEl() { return document.getElementById('cart-icon-bubble'); }
  function saveIcon() {
    var b = bubbleEl();
    var s = b && b.querySelector('svg');
    if (s && !iconSvg) iconSvg = s.cloneNode(true);
  }
  function restoreIcon() {
    var b = bubbleEl();
    if (!b || !iconSvg) return;
    var s = b.querySelector('svg');
    if (s && s.outerHTML !== iconSvg.outerHTML) s.replaceWith(iconSvg.cloneNode(true));
  }
  function watchIcon() {
    var b = bubbleEl();
    if (!b) return;
    saveIcon();
    if (iconObs) iconObs.disconnect();
    iconObs = new MutationObserver(restoreIcon);
    iconObs.observe(b, { childList: true, subtree: true });
    // the section may replace the whole element: watch its parent too
    if (b.parentElement) iconObs.observe(b.parentElement, { childList: true });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { applyDrawer(); orderCartPage(); updateArrows(); restoreIcon(); }, 60); }

  function boot() {
    watchIcon();
    schedule();
    var obs = new MutationObserver(schedule);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) obs.observe(drawer, { childList: true, subtree: true });
    if (/^\/cart/.test(location.pathname)) obs.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
